$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
      // zresetuj info box
      resetInfoBox();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }

  // při změně rozlišení resetujeme info box
  function resetInfoBox() {
    $('.info-box').removeClass('is-active');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  $('.nav a').on('click', function () {
    resetMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();

    // preloader
    // if ($('.preloader').length) {
    //   document.cookie = 'beenHere=1';
    //   document.querySelector('.preloader').classList.add('is-loaded');
    // }
  });

  // události při scroolování
  $(window).on('scroll', function () {
    //...
    if ($(this).scrollTop() > 1000) {
      $('.header').addClass('header--sticky');
    } else {
      $('.header').removeClass('header--sticky');
    }
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // before after slider (https://github.com/jotform/before-after.js)
  if ($('.ba-slider').length) {
    $('.ba-slider').beforeAfter();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    $('.js-video-start').on('click', function (event) {
      event.preventDefault();
    });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
        playsinline: 1,
        mute: 1,
      },
    });
  }

  // youtube video v modálním okně (vertikální video)
  if ($('.js-video-start-portrait').length) {
    $('.js-video-start-portrait').on('click', function (event) {
      event.preventDefault();
    });
    $('.js-video-start-portrait').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
        playsinline: 1,
        mute: 1,
      },
      ratio: '9:16',
      classNames: {
        modalVideo: 'modal-video modal-video--portrait',
        modalVideoClose: 'modal-video-close',
        modalVideoBody: 'modal-video-body',
        modalVideoInner: 'modal-video-inner',
        modalVideoIframeWrap: 'modal-video-movie-wrap',
        modalVideoCloseBtn: 'modal-video-close-btn',
      },
    });
  }

  // vimeo video v modálním okně
  if ($('.js-video-vimeo-start').length) {
    $('.js-video-vimeo-start').on('click', function (event) {
      event.preventDefault();
    });
    $('.js-video-vimeo-start').modalVideo({
      channel: 'vimeo',
    });
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  if ($('.front').length) {
    $('.front__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      asNavFor: '.front__nav',
      autoplay: true,
      autoplaySpeed: 5000,
    });
    $('.front__nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      infinite: true,
      asNavFor: '.front__slider',
    });
    $('.front__arrow').click(function () {
      $('.front__slider').slick('slickNext');
    });
  }

  if ($('.slider-default').length) {
    var sliderDefault = $('.slider-default');
    sliderDefault.each(function () {
      $(this).slick({
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        //prevArrow: $('.slider__arrow-right'),
        //nextArrow: $('.slider__arrow-left'),
        prevArrow: $(this).siblings().find('.slider__arrow-left'),
        nextArrow: $(this).siblings().find('.slider__arrow-right'),
        fade: false,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        adaptiveHeight: false,
        touchThreshold: 1000,
        swipeToSlide: true,
        // focusOnSelect: true,
        // pauseOnFocus: true,
        // pauseOnHover: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: false,
              slidesToShow: 2,
            },
          },
        ],
      });
    });
  }

  if ($('.slider-video').length) {
    var sliderVideo = $('.slider-video');
    sliderVideo.each(function () {
      $(this).slick({
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $(this).siblings().find('.slider__arrow-left'),
        nextArrow: $(this).siblings().find('.slider__arrow-right'),
        fade: false,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        adaptiveHeight: false,
        touchThreshold: 1000,
        swipeToSlide: true,
        // focusOnSelect: true,
        // pauseOnFocus: true,
        // pauseOnHover: true,
      });
    });
  }

  if ($('.enjoy__slider').length) {
    $('.enjoy__slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      fade: false,
      autoplay: false,
      autoplaySpeed: 0,
      //speed: 3000,
      draggable: true,
      lazyLoad: 'progressive',
      easing: 'linear',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  }

  if ($('.sales-testimonials__slider').length) {
    $('.sales-testimonials__slider').slick({
      slidesToShow: 2.6,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.sales-testimonials__prev'),
      nextArrow: $('.sales-testimonials__next'),
      dots: false,
      infinite: false,
      fade: false,
      autoplay: false,
      autoplaySpeed: 0,
      //speed: 3000,
      draggable: true,
      lazyLoad: 'progressive',
      easing: 'linear',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    });
  }

  // video
  if ($('.video').length) {
    $('.video').on('click', function () {
      if ($(this).children('video').get(0).paused) {
        $(this).children('video').get(0).play();
        $(this).children('.video__play, .video__overlay').fadeOut();
        $(this).closest('.slider-default').slick('slickPause');
        $(this).closest('.slider-video').slick('slickPause');
        //$(this).children('video').prop('controls', 'controls'); // video controls
      } else {
        $(this).children('video').get(0).pause();
        $(this).children('.video__play, .video__overlay').fadeIn();
        //$(this).children('video').prop('controls', ''); // video controls
      }
    });
  }

  // efekt načítání čísla
  // https://stackoverflow.com/questions/49260085/make-numbers-animate-when-user-scrolls-and-reach-a-div
  if ($('.js-number').length) {
    var section = document.querySelector('.number');
    var hasEntered = false;

    window.addEventListener('scroll', (e) => {
      var shouldAnimate =
        window.scrollY + window.innerHeight >= section.offsetTop;

      if (shouldAnimate && !hasEntered) {
        hasEntered = true;

        $('.js-number').each(function () {
          $(this)
            .prop('Counter', 0)
            .animate(
              {
                Counter: $(this).text(),
              },
              {
                duration: 3000,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now));
                },
              }
            );
        });
      }
    });
  }

  // efekt načítání čísla
  if ($('.js-counter').length) {
    var oTop = $('.js-counter').offset().top - window.innerHeight / 1.5;
    var onlyOnce = true;

    if (onlyOnce) {
      $(window).scroll(function () {
        var pTop = $(window).scrollTop();
        if (pTop > oTop) {
          onlyOnce = false;
          counter();
        }
      });
    }
  }

  if ($('.reference-simple-list').length) {
    $('.reference-simple-list__wrap').masonry({
      //columnWidth: 290,
      itemSelector: '.reference-simple',
      horizontalOrder: true,
    });
  }

  if ($('.js-references').length) {
    referencesFilter();
  }

  if ($('.info-box__read-more').length) {
    $('.info-box__read-more').on('click', function () {
      if ($(this).closest('.info-box').hasClass('is-active')) {
        $(this).closest('.info-box').removeClass('is-active');
      } else {
        $(this).closest('.info-box').addClass('is-active');
      }
    });
    $('.info-box__back-close').on('click', function () {
      if ($(this).closest('.info-box').hasClass('is-active')) {
        $(this).closest('.info-box').removeClass('is-active');
      } else {
        $(this).closest('.info-box').addClass('is-active');
      }
    });
  }

  if ($('#contact-form').length) {
    const contactForm = document.getElementById('contact-form');
    initContactForm(contactForm);
  }

  if ($('#newsletter-form').length) {
    console.log('test');
    const newsletterForm = document.getElementById('newsletter-form');
    initContactForm(newsletterForm);
  }

  if ($('#sales-form').length) {
    const contactForm = document.getElementById('sales-form');
    initSalesForm(contactForm);
  }

  // faq
  if (document.querySelector('.sales-faq')) {
    faqQuestion = document.getElementsByClassName('sales-faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.sales-faq__item').classList.contains('is-open')) {
          this.closest('.sales-faq__item').classList.remove('is-open');
        } else {
          this.closest('.sales-faq__item').classList.add('is-open');
        }
      });
    }
  }
  // front__clients-2
  if ($('.front__clients-2').length) {
    // Funkce pro inicializaci animace log klientů
    function initClientsAnimation() {
      const clientsContainer = $('.front__clients-2');
      const clientLogos = clientsContainer.find('img');

      // Označení log pro sledování
      clientLogos.each(function (index) {
        $(this).attr('data-index', index);
      });

      // Funkce pro detekci viditelnosti a nastavení animace
      function setupClientLogosAnimation() {
        // Zjištění počtu viditelných sloupců podle CSS
        const containerStyle = window.getComputedStyle(clientsContainer[0]);
        const gridColumns =
          containerStyle.gridTemplateColumns.split(' ').length;

        // Pokud nemáme validní počet sloupců, použijeme výchozí hodnotu 3
        const visibleColumns = gridColumns > 0 ? gridColumns : 3;

        // Zjištění počtu logo v jednom řádku
        const logosPerRow = visibleColumns;

        // Skrytí všech log
        clientLogos.removeClass('is-show-animation').addClass('is-hidden');

        // Rozdělení log do skupin podle počtu viditelných sloupců
        const groups = [];
        for (let i = 0; i < clientLogos.length; i += logosPerRow) {
          groups.push(clientLogos.slice(i, i + logosPerRow));
        }

        // Vytvořit funkci pro rotaci skupin log s fade efektem
        let currentGroupIndex = 0;

        // Zobrazit první skupinu
        if (groups[0]) {
          $(groups[0]).removeClass('is-hidden').addClass('is-show-animation');
        }

        // Deklarace proměnné pro uložení ID intervalu
        let animationInterval;

        // Nastavení intervalu pro změnu zobrazené skupiny
        if (groups.length > 1) {
          animationInterval = setInterval(function () {
            // Skrýt aktuální skupinu
            if (groups[currentGroupIndex]) {
              $(groups[currentGroupIndex])
                .removeClass('is-show-animation')
                .addClass('is-hidden');
            }

            // Přejít na další skupinu nebo se vrátit na začátek
            currentGroupIndex = (currentGroupIndex + 1) % groups.length;

            // Zobrazit novou skupinu
            if (groups[currentGroupIndex]) {
              $(groups[currentGroupIndex])
                .removeClass('is-hidden')
                .addClass('is-show-animation');
            }
          }, 5000); // 5000ms = 5s
        }

        // Vrátit ID intervalu pro pozdější vyčištění
        return animationInterval;
      }

      // Proměnná pro uložení aktuálního intervalu
      let currentInterval;

      // Spustit nastavení animace
      currentInterval = setupClientLogosAnimation();

      // Reagovat na změnu velikosti okna
      $(window).on('resize', function () {
        // Zrušit pouze náš interval
        if (currentInterval) {
          clearInterval(currentInterval);
        }

        // Znovu nastavit animaci po změně velikosti
        currentInterval = setupClientLogosAnimation();
      });
    }

    // Inicializace animace
    initClientsAnimation();
  }
});
